import { z } from "zod";

export const SettingTypeSchema = z.enum(["boolean", "string"]);
export const DisplayTypeSchema = z.enum(["Switch", "Radio", "Dropdown"]);

export const SettingSchema = z.object({
  name: z.string(),
  type: SettingTypeSchema,
  display_type: DisplayTypeSchema,
  available_options: z.array(z.union([z.string(), z.boolean()])).optional(),
  default_option: z.union([z.string(), z.boolean()]),
  selected_option: z.union([z.string(), z.boolean()]).optional(),
});

export const RecommendedPromptSchema = z.object({
  user_prompt_fe: z.string().min(1, "Frontend prompt must not be empty."),
  user_prompt_be: z.string().min(1, "Backend prompt must not be empty."),
  type: z.enum(["popularity", "ai-assisted"]),
});

export const UserSettingsSchema = z.object({
  user: z.string(),
  settings: z.array(SettingSchema),
  recommended_prompt: z.array(RecommendedPromptSchema),
});

export type Setting = z.infer<typeof SettingSchema>;
export type RecommendedPrompt = z.infer<typeof RecommendedPromptSchema>;
export type UserSettings = z.infer<typeof UserSettingsSchema>;

export type ChatSettingsType = Record<string, Setting>;
export type TempSettingsType = Record<string, string | boolean>;
